import { APP_BASE_HREF, Location } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { NavigationExtras } from "@angular/router";
import { isExternalUrl } from "@obg/ngx.global";
import { Observable, of } from "rxjs";

import { RouteService } from "./../store/route.service";
import { HREF_LINKS } from "./route-link.const";
import { RouteLink } from "./route-link.model";
import { extractRouteLink } from "./route-link.util";

@Injectable({
	providedIn: "root",
})
export class RouteLinkService {
	constructor(
		private routeService: RouteService,
		private location: Location,
		@Inject(APP_BASE_HREF) private appBaseHref: string
	) {}

	getExternalUrlFromRouteLink(routeLink: RouteLink): string | undefined {
		if (routeLink.route) {
			return this.routeService.generateUrl({
				routeName: routeLink.route,
				params: routeLink.params,
			});
		}

		if (routeLink.url) {
			const baselessUrl = this.removeBase(routeLink.url.replace(/^\/?/, "/"));
			return this.location.prepareExternalUrl(baselessUrl);
		}

		return undefined;
	}

	removeBase(url: string): string {
		if (url.startsWith(`${this.appBaseHref}/`) || url === this.appBaseHref) {
			return url.replace(this.appBaseHref, "");
		}

		return url;
	}

	getUrl(incomingRoute: RouteLink, extras?: NavigationExtras): string | undefined {
		const routeLink = extractRouteLink(incomingRoute);

		const { route, params } = routeLink;
		let { url } = routeLink;

		if (route) {
			url = this.routeService.generateUrl({ routeName: route, params, extras });
		} else if (url) {
			if (!isExternalUrl(url) && !HREF_LINKS.some((protocol) => url!.startsWith(protocol))) {
				url = this.getExternalUrlFromRouteLink(routeLink as RouteLink);
			}
		}

		return url;
	}

	getUrl$(incomingRoute: RouteLink, extras?: NavigationExtras): Observable<string | undefined> {
		const { route, params } = extractRouteLink(incomingRoute);

		if (route) {
			return this.routeService.generateUrl$({ routeName: route, params, extras });
		}

		return of(this.getUrl(incomingRoute, extras));
	}

	isAbsoluteUrl(url: string): boolean {
		return url.startsWith("http://") || url.startsWith("https://");
	}
}
